<!-- For updated replace a vehicle flow (with bind) -->
<layout-sidebar>
  <div class="replace-vehicle main">
    <div class="row">
      <div class="column twelve">
        <h4 class="heading-sub-section">Let's get started</h4>
        <p class="pad-top-10">
          To replace a vehicle on your policy, we’ll need the VIN and vehicle year.
        </p>
      </div>
    </div>

    <ds-year-vin-lookup [policyNumber]="policyNumber" [replaceVin]="replaceVin">
    </ds-year-vin-lookup>
  </div>
  <aside class="main-aside"><links-agents-sidebar></links-agents-sidebar></aside>
</layout-sidebar>
